import { render } from "./TestResultContent.vue?vue&type=template&id=4ea4af41&scoped=true"
import script from "./TestResultContent.vue?vue&type=script&lang=js"
export * from "./TestResultContent.vue?vue&type=script&lang=js"

import "./TestResultContent.vue?vue&type=style&index=0&id=4ea4af41&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea4af41"]])

export default __exports__